import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import { ExpandIcon } from 'common/components/icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { LoadBalancerIcon, ErrorIcon, WarningIcon } from '../../../../common/components/icons';
import Grid from '@material-ui/core/Grid';
import CwafPanel from './CwafPanel';
import { Tooltip } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Theme from '../../../../Theme';
import { ThemeProvider } from 'styled-components';
const styles = {
    root: {
        width: '100%',
    },
    shadow: {
        webkitFilter: 'drop-shadow( 1px 2px 3px rgba(0, 0, 0, .7))',
        filter: 'drop-shadow( 1px 2px 3px rgba(0, 0, 0, .7))',
        /* Similar syntax to box-shadow */
    },
    cwafExpansionIcon: {
        left: '390px',
        right: 'auto',
        top: '13px',
        transition: 'none',
        "&$expanded": {
            transform: "translateY(-50%) rotate(45deg)"
        }
    },
    appAccordion: {
        boxShadow: 'none',
        minHeight: '0 !important'
    },
    appAccordionSummaryRoot: {
        minHeight: '0 !important'
    },
    appAccordionSummary: {
        padding: '0px',
        minHeight: '0 !important',
        margin: 0
    },
    appExpansionSummaryContent: {
        minHeight: '0 !important',
        margin: '0px !important'
    },
    appExpansionSummaryExpanded: {
        height: '20px',
        minHeight: '0 !important',
        margin: 0
    },
    appAccordionExpanded: {
        paddingLeft: '80px',
        paddingTop: '0px'
    },
    typography: {
        display: "inline-block"
    },
    regionIdLabel: {
        extend: 'typography',
        paddingTop: '1.5px',
        paddingLeft: '5px',
    },
    lbCountLabel: {
        extend: 'typography',
        paddingTop: '1.5px'
    },
    table: {
        width: '100%'
    },
    warningIcon: {
        marginTop: '1px',
        paddingRight: '3px'
    },
    lbLabel: {
        marginTop: '-10px'
    },
    tabeCell: {
        verticalAlign: "top",
        paddingTop: '10px'
    },
    appNameContainer: {
        display: 'inline-block',
        paddingRight: '5px'
    },
    typographyError: {
        extend: 'typography',
        color: '#f44336'
    },
    typographyWarning: {
        extend: 'typography',
        color: '#ffc107'
    },
    lbIconCell: {
        width: '70px', 
        paddingTop: '10px'
    },
};

const StyledChip = withStyles((theme) => ({
    root: {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        borderRadius: '10px',
        padding: '0 4px',
        height: '20px',
        marginBottom: '2px',
    },
    label: {
        fontSize: '0.6rem',
        paddingLeft: '0px',
        paddingRight: '0px',
    }
}))(Chip);

class RegionPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }


    shouldComponentUpdate(nextProps, nextState){
        // return nextProps.shouldUpdate === this.props.regionName || 
        //        nextProps.shouldUpdate === 'all';
        return nextProps.shouldUpdate;
    }

    render() {

        const {
            classes,
            // isLoading,
            regionData,
            regionName,
            // reload,
            regionPanels,
            togglePanel,
            regionStatus,
            regionAppCount,
            // regionId,
            // shouldUpdate,
            setShouldUpdate,
        } = this.props;
        
        return <Accordion expanded={this.props.expanded} onChange={() => togglePanel({ type: 'REGION', region: regionName, lb: 0, cwaf: 0 })}>
            <AccordionSummary
                expandIcon={<ExpandIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <div className={classes.warningIcon}>
                    {regionStatus === 'ERROR' ? <ErrorIcon /> : regionStatus === 'WARNING' ? <WarningIcon /> : ""}
                </div>
                <Grid container>
                    <Grid item container xs={10}>
                        <ThemeProvider theme={Theme}>

                            <Typography className={regionStatus === 'ERROR' ? classes.typographyError : regionStatus === 'WARNING' ? classes.typographyWarning : classes.typography} variant='subtitle2'>{regionName}</Typography>
                        </ThemeProvider>
                        <Typography className={classes.regionIdLabel} variant='caption' color="textSecondary">({regionData['id']})</Typography>
                    </Grid>
                    <Grid item xs={1} container justifyContent='flex-end'>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">#LB's:{Object.keys(regionData['lb']).length}</Typography>
                    </Grid>
                    <Grid item xs={1} container justifyContent='flex-end'>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">| {regionAppCount} Apps</Typography>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Table className={classes.table}>
                    <TableBody>
                        {Object.keys(regionData['lb']).map((lb, lb_id) =>
                            <TableRow key={`lb#${lb_id}`}>
                                <TableCell className={classes.lbIconCell}>
                                    <Grid container alignItems="center">
                                        <Grid item>
                                            <LoadBalancerIcon className={classes.shadow} />
                                            <Typography className={classes.lbLabel} variant='overline' align="center">LB{lb}</Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>

                                <TableCell className={classes.tabeCell}>
                                    {regionData['lb'][lb].apps.length <= 8 ?
                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Typography color="textSecondary" className={classes.typography}>
                                                    {regionData['lb'][lb].apps.length > 0 ? "Applications:" : "No Applications"}
                                                </Typography>
                                            </Grid>
                                            {regionData['lb'][lb].apps.map((app, appIndex) =>
                                                <Grid item className={classes.appNameContainer} key={`app${appIndex}`}>
                                                    <Tooltip title={app.account + "," + app.account_id}>
                                                        <Typography color="primary" className={classes.typography} onClick={event => event.stopPropagation()}>
                                                            {app.name}
                                                        </Typography>
                                                    </Tooltip>
                                                    {/* indicate DEV accounts */}
                                                    {app.is_dev &&
                                                        <StyledChip label='DEV'></StyledChip>
                                                    }
                                                    {appIndex < regionData['lb'][lb].apps.length - 1 ? "," : ""}
                                                </Grid>
                                            )}
                                        </Grid>
                                        :
                                        <Accordion className={classes.appAccordion}>
                                            <AccordionSummary aria-controls="additional-actions2-content"
                                                className={classes.appAccordionSummary}
                                                classes={{
                                                    root: classes.appAccordionSummaryRoot,
                                                    content: classes.appExpansionSummaryContent,
                                                    expanded: classes.appExpansionSummaryExpanded,
                                                    expandIcon: classes.cwafExpansionIcon
                                                }}>
                                                <Grid container spacing={1}>
                                                    <Grid item>
                                                        <Typography color="textSecondary" className={classes.typography}>
                                                            Applications:
                                                        </Typography>
                                                    </Grid>
                                                    {regionData['lb'][lb].apps.slice(0, 8).map((app, appIndex) =>
                                                        <Grid item className={classes.appNameContainer} key={`app#${appIndex}`}>
                                                            <Tooltip title={app.account + "," + app.account_id}>
                                                                <Typography color="primary" className={classes.typography} onClick={event => event.stopPropagation()}>
                                                                    {app.name}
                                                                </Typography>
                                                            </Tooltip>
                                                            {/* indicate DEV accounts */}
                                                            {app.is_dev &&
                                                                <StyledChip label='DEV'></StyledChip>
                                                            }
                                                            {appIndex < regionData['lb'][lb].apps.length - 1 ? "," : ""}
                                                        </Grid>
                                                    )}
                                                    <Grid item>
                                                        <Typography color='primary'>...</Typography>
                                                    </Grid>
                                                </Grid>
                                            </AccordionSummary>
                                            <AccordionDetails className={classes.appAccordionExpanded}>
                                                <Grid container spacing={1}>
                                                    {regionData['lb'][lb].apps.slice(8).map((app, appIndex) =>
                                                        <Grid item className={classes.appNameContainer} key={`app#${appIndex}`}>
                                                            <Tooltip title={app.account + "," + app.account_id}>
                                                                <Typography color="primary" className={classes.typography} onClick={event => event.stopPropagation()}>
                                                                    {app.name}
                                                                </Typography>
                                                            </Tooltip>
                                                            {/* indicate DEV accounts */}
                                                            {app.is_dev &&
                                                                <StyledChip label='DEV'></StyledChip>
                                                            }
                                                            {appIndex < regionData['lb'][lb].apps.length - 1 ? "," : ""}
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    }
                                    {regionData['lb'][lb].cwaf.map((cwaf, cwafId) =>
                                        <CwafPanel key={`cwaf#${cwafId}`}
                                            cwaf={cwaf}
                                            expanded={regionPanels[lb][cwafId].expanded}
                                            togglePanel={() => togglePanel({ type: 'CWAF', region: regionName, lb: lb, cwaf: cwafId })}
                                            setShouldUpdate={setShouldUpdate}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </AccordionDetails>
        </Accordion>
    }
};

export default withStyles(styles)(RegionPanel);